import React from 'react';
import { collection, doc, query, where, getDocs, setDoc } from 'firebase/firestore';
import { firestore } from '../../../../config/firebase';
import { Button, Col, Form, Input, Modal, Row, Space, Tooltip, message } from 'antd';
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { useEffect, useState } from 'react';
const initialState = { question: "" }
export default function AdminQuestion() {
  const [state, setState] = useState(initialState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForUpdate, setIsModalOpenForUpdate] = useState(false);
  const [questionsData, setquestionsData] = useState([]);
  const deletequestion = async (question) => {
    let deletedquestion = { ...question, status: "deleted" }
    try {
      await setDoc(doc(firestore, "questions", deletedquestion.questionId), deletedquestion);
      let questionsDataAfterDelete = questionsData.filter((question) => question.questionId !== deletedquestion.questionId)
      setquestionsData(questionsDataAfterDelete)
      message.success("The question Deleted successfully")
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }
  const handleChange = (e) => {
    setState((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
  };

  const addquestionToFirestore = async (questionData) => {
    try {
      await setDoc(doc(firestore, 'questions', questionData.questionId), questionData);
      setquestionsData([questionData, ...questionsData]);
      message.success('The question Added successfully');
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error adding document: ', error);
    }
  };

  const handleUpdatequestion = async () => {
    const updatedquestionsData = questionsData.map((question) => {
      if (question.questionId === state.questionId) {
        return { ...question, ...state };
      }
      return question;
    });
    try {
      await setDoc(doc(firestore, 'questions', state.questionId), state);
      setquestionsData(updatedquestionsData);
      message.success('The question Updated successfully');
      setIsModalOpenForUpdate(false);
    }
    catch (error) {
      console.error('Error updating document: ', error);
    }
  };

  const handleAddquestion = async () => {
    const questionId = Math.random().toString(36).slice(2);
    const questionData = {
      ...state,
      createdAt: new Date().toLocaleString(),
      questionId,
      status: 'active',
    };
    if (!questionData.question) {
      message.error('FILL THE INPUT');
      return;
    }

    addquestionToFirestore(questionData);
  };


  useEffect(() => {
    // Fetch questions data from Firestore when component mounts
    const getquestionsFromFirestore = async () => {
      const q = query(collection(firestore, 'questions'), where('status', '==', 'active'));
      const querySnapshot = await getDocs(q);
      const array = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        array.push(data);
      });
      setquestionsData(array);
    };

    getquestionsFromFirestore();
  }, []);
  return (
    <>
      <h1 className=' text-[#fffa8a] pt-24 font-bold text-[48px] text-center italic'>All questions Table</h1>
      <div className="flex justify-content-center  mt-5">
        <Button

          className="px-10  text-center rounded-2xl mx-auto  hover:rounded-lg"
          style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }} onClick={() => setIsModalOpen(true)}
        >
          Add question
        </Button></div>
      <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
        <div className="py-8">
          <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
            <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
              <table className="min-w-full leading-normal" >
                <thead>
                  <tr>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Question
                    </th>
                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {questionsData.map((rowData, index) => (
                    <tr key={index}>
                      <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                        <div className="flex items-center">
                          <div>
                            <p className=" whitespace-no-wrap">{rowData.question}</p>
                          </div>
                        </div>
                    </td>
                      <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                        <Space>
                          <Tooltip title="Delete" color='red'  ><Button onClick={() => deletequestion(rowData)} danger icon={<DeleteOutlined />} /></Tooltip>
                          <Tooltip title="Edit"  ><Button type="primary" icon={<EditOutlined className='text-[#fffa8a]' onClick={() => {
                            setIsModalOpenForUpdate(true)
                            setState(rowData)
                          }} />} /></Tooltip>
                        </Space>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      );
      <Modal
        title="ADD question"
        centered
        open={isModalOpen}
        onOk={handleAddquestion}
        okText="Confirm"
        okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
        cancelText="Close"
        onCancel={() => setIsModalOpen(false)}
        style={{ maxWidth: 1000 }}
      >
        <Form layout="vertical" className='py-4'>
          <Row gutter={16}>
            <Col xs={24} lg={24}>
              <Form.Item label="Question">
                <Input placeholder='Input your Question' name='question' onChange={handleChange} />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-content-center">
            <Button onClick={handleAddquestion} className='mx-auto mt-5 text-center'>Add question</Button></div>
        </Form>
      </Modal>
      <Modal
        title="Update question"
        centered
        open={isModalOpenForUpdate}
        onOk={handleUpdatequestion}
        okText="Confirm"
        okButtonProps={{ type: 'primary', color: "primary", className: ' text-center rounded-2xl text-black   hover:rounded-lg ' }}
        cancelText="Close"
        onCancel={() => setIsModalOpenForUpdate(false)}
        style={{ maxWidth: 1000 }}
      >
        <Form layout="vertical" className='py-4'>
          <Row gutter={16}>
            <Col xs={24} lg={24}>
              <Form.Item label="Question">
                <Input placeholder='Input your Question' name='question' value={state.question} onChange={handleChange} />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-content-center">
            <Button onClick={handleUpdatequestion} className='mx-auto mt-5 text-center'>Update question</Button></div>
        </Form>
      </Modal>
    </>
  )
}
